<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="devTrackingCode"
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :cell-class-name="cellClassName"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ trigger: 'row', highlight: true, reserve: true }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:displayImage="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width: 100px; height: 66px"
          fit="cover"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:sampleNameInfo="{ row }">
        <span>{{ row.devTrackingNo }}</span>
        <br />
        <span>{{ row.sampleName }}</span>
        <br />
        <span>{{ row.sampleNameEn }}</span>
      </template>
      <template v-slot:devStatus="{ row }">
        {{ row.v_devStatus }}
      </template>
      <template v-slot:selectionFace="{ row }">
        <span>{{ row.proposalStyleNo }}</span>
        <br />
        <span>{{ row.sampleName }}</span>
      </template>

      <template v-slot:sampleSize="{ row }">
        <span
          >{{ $l('label_sample_size') || '尺寸' }}：{{ row.sampleSize }}</span
        >
      </template>
      <template v-slot:smcFtyPrice="{ row }">
        <span
          >{{ $l('label_cost_price') || '成本价格' }}：{{ row.ftyPrice }}
          {{ row.v_ftyCurrencyUnit }}</span
        >
        <br />
        <span>{{ row.sampleScmName }}</span>
      </template>

      <template v-slot:custName="{ row }">
        <span>{{ row.custName }}</span>
        <span v-if="row.endCustName">/{{ rwo.endCustName }}</span>
      </template>
      <template v-slot:selector="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>

      <template v-slot:originalSample="{ row }">
        <span>{{ row.sampleStyleNo }}</span>
        <br />
        <span>{{ row.originalSampleName }}</span>
        <br />
        <span>{{ row.originalSampleNameEn }}</span>
      </template>

      <template v-slot:categoryAndSize="{ row }">
        <span
          >{{ $l('label_category') || '品类' }}：{{ row.categoryName }}</span
        >
        <br />
        <span
          >{{ $l('label_sample_size') || '尺寸' }}：{{ row.sampleSize }}</span
        >
      </template>

      <template v-slot:modify="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
export default {
  mixins: [EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    tableHeight: { type: Number, default: 300 },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {},
  methods: {
    cellClassName({ column }) {
      return column.property === 'col-opt' ? '' : 'align-top'
    },
    checkboxChange({ records, reserves }) {
      this.$emit('choose-change', records.concat(reserves))
    },
  },
}
</script>
